import { render, staticRenderFns } from "./invoicemntsTable.vue?vue&type=template&id=23ff6214&"
import script from "./invoicemntsTable.vue?vue&type=script&lang=js&"
export * from "./invoicemntsTable.vue?vue&type=script&lang=js&"
import style0 from "./invoicemntsTable.vue?vue&type=style&index=0&id=23ff6214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports